
import Payments             from '@/components/frontOffice/Payments.vue'
import SalesList            from '@/components/frontOffice/SalesList.vue'
import CouponList           from '@/components/frontOffice/coupon/CouponList.vue'

import PromoCouponList      from '@/components/frontOffice/PromoCoupon/PromoCouponList.vue'

const menuId = 'fo1'
const routes = [
    {
        path        : '/desk',
        name        : 'cart',
        //component   : Cart,
        //component   : () => import('@/components/frontOffice/Cart.vue'),
        component   : () => import('@/components/frontOffice/cart/cartTable.vue'),
        meta        : { name : 'Vendita al banco', visible : true ,icon : 'fas fa-cart-arrow-down',menu:menuId,color:'#FF9900'},
        //props       : (route) => ({ saleId: route.query.q })  
    },

   
    {
        path        : '/payment', 
        component   : Payments,
        name        : 'counterPayments',
        meta        : { name : 'Controllo cassa', visible : true ,icon : 'fas fa-cash-register',menu:menuId,color:'green'},   
    },
    
    {
        path        : '/sales/list', 
        component   : SalesList,
        name        : 'counterSales',
        meta        : { name : 'Operazioni di vendita/reso', visible : true ,icon : 'far fa-list-alt',menu:menuId,color:'black'},   
    },
    {
        path        : '/couponList', 
        component   : CouponList,
        name        : 'couponList',
        meta        : { name : 'Gift card e Cashback di cassa ', visible : true ,icon : 'fas fa-money-check-alt',menu:menuId,color:'blue'},   
    },
    
    {
        path        : '/promoCouponList', 
        component   : PromoCouponList,
        name        : 'PromoCouponList',
        meta        : { name : 'Promo coupon ', visible : true ,icon : 'fas fa-coins',menu:menuId,color:'blue'},   
    },
    
  
            
]
export default routes
